export const LEGAL = 1; // 法务
export const LAWYER = 0; // 律师
